const isTruthy = (value) => !!value;

// noinspection JSUnusedGlobalSymbols
export default isTruthy;
